import { atom } from 'jotai';
import { $SearchParams } from './remix';
export const $EmailTraffic = atom((get) => {
    const sp = get($SearchParams);
    return {
        msgId: sp.get('msg_id') || '',
        edmClickPosition: sp.get('edm_click_position') || '',
        edmTemplateId: sp.get('edm_template_id') || '',
    };
});
$EmailTraffic.debugLabel = '$EmailTraffic';
